// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28759":"01183b73","66289":"5cadb3d0"}[chunkId] + ".chunk.css";
};